module.exports = __webpack_public_path__ + "static/media/Madfit-12.20c6d03a.jpg";